import React, { useEffect } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
import { useDispatch } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setRoadmapData } from "../../../../../Redux/slices/mngrSlice";
import { post_subcategory_roadmap } from "http/components/Roadmap";
import MuiRadioGroup from "Utils/Helpers/MuiRadioGroup";

export default function AddSubCategoryRoadmapData({ data }) {
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    level: {
      display: true,
      label: "Level",
      type: "text",
      multiLine: false,
      placeholder: "Level",
      value: "",
      validation: false,
    },
    description: {
      display: true,
      label: "Description",
      type: "text",
      multiLine: true,
      placeholder: "Description",
      value: "",
      validation: false,
    },
    category: {
      display: true,
      label: "Category",
      type: "radio",
      value: "",
      items: [],
    },
    status: {
      display: true,
      label: "Status",
      type: "radio",
      value: "",
      items: [
        { key: "Undone", value: "2" },
        { key: "Pending", value: "3" },
        { key: "Done", value: "4" },
      ],
    },
    progress: {
      display: false,
      label: "Progress (0 - 100)",
      type: "number",
      multiLine: false,
      placeholder: "Progress",
      value: 0,
      validation: false,
    },
  });

  useEffect(() => {
    onClear();
  }, [data]);

  const onClear = () => {
    setControls({ level: { value: "", validation: false } });
    setControls({ description: { value: "", validation: false } });
    setControls({ progress: { value: 0, validation: true } });
    setControls({ status: { value: controls.status.items[0] } });
    const items = data.map((i) => {
      return {
        key: i.title,
        value: i.id,
      };
    });
    setControls({
      category: {
        items,
        value: items[0],
      },
    });
  };

  const setValue = (name, value, validation) => {
    let _value = value;
    if (name === "progress") {
      if (!_value || +_value < 0) _value = 0;
      if (+_value > 100) _value = 100;
    }
    setControls({ [name]: { value: _value, validation } });
  };

  const onChangeRadio = (name, value) => {
    setControls({ [name]: { value: value } });
    if (name === "status") {
      setControls({
        progress: {
          display: ["2", "4"].includes(value.value) ? false : true,
          value: ["2", "3"].includes(value.value) ? "0" : "100",
          validation: true,
        },
      });
    }
  };

  const onSubmit = async () => {
    const { level, description, category, status, progress } = controls;
    if (level.validation && description.validation && progress.validation) {
      dispatch(HandleLoading(true));
      const response = await post_subcategory_roadmap({
        title: level.value,
        description: description.value,
        category: category.value.value,
        status: +status.value.value,
        value: +progress.value,
      });
      if (CheckApiStatus(response)) {
        onClear();
        dispatch(setRoadmapData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <Grid2 container spacing={2}>
      {Object.keys(controls)
        .filter((key) => controls[key].display)
        .map((key, index) => {
          return (
            <Grid2 size={{ xs: 12 }} key={key + index}>
              {["text", "number"].includes(controls[key].type) && (
                <Inputer
                  id={key}
                  setValue={setValue.bind(this)}
                  value={controls[key].value}
                  label={controls[key].label}
                  placeholder={controls[key].placeholder}
                  type={controls[key].type}
                  multiLine={controls[key].multiLine}
                />
              )}
              {controls[key].type === "radio" && (
                <MuiRadioGroup
                  name={key}
                  value={controls[key].value}
                  label={controls[key].label}
                  items={controls[key].items}
                  onChange={onChangeRadio}
                />
              )}
            </Grid2>
          );
        })}
      <Grid2 size={{ xs: 12 }}>
        <MButton label={"Save"} onClick={onSubmit} />
      </Grid2>
    </Grid2>
  );
}
